export function contentKind(item) {
  if (item.contentKind) return item.contentKind;
  if (item.type !== "resource") return "videos";
  return item.attachments?.some(file => file.mime?.startsWith("image/")) ? "photos" : "documents";
}
export function contentDuration(item) {
  const seconds = Number(item.hls?.duration || item.video?.duration || item.duration);
  if (!Number.isFinite(seconds) || seconds <= 0) return item.type === "live" ? "Live class" : "Duration pending";
  const total = Math.floor(seconds), hours = Math.floor(total / 3600);
  return (hours ? hours + ":" : "") + (hours ? String(Math.floor(total / 60) % 60).padStart(2, "0") : Math.floor(total / 60)) + ":" + String(total % 60).padStart(2, "0");
}
